import React  from 'react';
import styled from 'styled-components';
const Styles = styled.div`
  margin: 0.5rem 0;
  .box-stages {
    width: calc(100% - calc(var(--universal-pad) * 2));
    margin: 0 var(--universal-pad);
    /* background-color: var(--n-grey-0); */
    /* box-shadow: 0px 4px 50px -16px #00000028; */
    /* border-radius: var(--border-radius-32); */
    position: relative;
    display: flex;
    gap: 0.5rem;
    isolation: isolate;
    .main {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;
      flex-grow: 1;
      &.normal-box, &.normal-box-reverse {
        background-color: var(--n-grey-0);
        box-shadow: 0px 4px 50px -16px #00000028;
        border-radius: var(--border-radius-32);
        padding: 1rem 1rem;
      }
      &.normal-box-reverse, &.normal-reverse {
        flex-direction: row-reverse;
        .image {
          background-color: transparent;
          border: none;
          img {
            object-fit: contain;
          }
        }
      }
      
      /* max-width: 30%; */
      .image {
        width: 50%;
        aspect-ratio: 2;
        border-radius: var(--border-radius-3);
        overflow: hidden;
        background-color: var(--n-grey-0);
        border: 1px solid var(--n-grey-11);
        img {
          display: block;
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
      .data {
        width: 50%;
      }
      .title {
        /* background-color: var(--n-grey-0); */
        font-size: 1rem;
        font-weight: 700;
        padding: 0 0 0.5rem;
      }
      .desc {
        white-space: pre-line;
        /* background-color: var(--n-grey-0); */
      }
    }
  }
  @media screen and (max-width: 850px) {
    .box-stages {
      flex-direction: column;
      &::before {
        position: absolute;
        top: 50px;
        bottom: 50px;
        left: 50%;
        right: auto;
        border-right: 1px dashed var(--n-grey-2);
      }
      .main {
        max-width: none;
        flex-direction: column;
        &.normal-box-reverse, &.normal-reverse {
          flex-direction: column-reverse;
        }
        .image {
          width: 100%;
        }
        .data {
          width: 100%;
        }
      }
    }
  }
`
export default function BoxImageText30 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const models = () => {
    switch(data.model){
      case "1":
        return "normal-box";
      case "2":
        return "normal-box-reverse"
      case "3":
        return "normal"
      case "4":
        return "normal-reverse"
      default:
        return ""
    }
  }
  return (
    <Styles>
      <div className='box-stages'>
        <div className={'main ' + models()}>
          <div className='image'>
            <img src={data.icon} alt={data.title}/>
          </div>
          <div className='data'>
            <div className='title'>
              {data.title}
            </div>
            <pre className='desc'>
              {data.text}
            </pre>
          </div>
        </div>
      </div>
    </Styles>
  )
}

